import { media } from "./media";
import { EXPORT_TIER, PRODUCTION_FACILITY } from "./packaging";
import { ANNUAL_DISCOUNT_PERCENT } from "./pricing";

export const SITE_ORIGIN = "https://loop.variant3d.io";

export type RouteMeta = {
  readonly path: string;
  readonly title: string;
  readonly description: string;
  readonly ogTitle: string;
  readonly ogDescription: string;
  readonly ogImage: string;
};

export const HOME_META: RouteMeta = {
  path: import.meta.env.BASE_URL,
  title: "LOOP™ by VARIANT3D — 3D design to knit-ready output",
  description:
    "LOOP connects creative 3D design to knit manufacturing, carrying design intent into a workflow informed by real knitting knowledge.",
  ogTitle: "LOOP™ by VARIANT3D — 3D design to knit-ready output",
  ogDescription: "Bridge creative 3D design and knit manufacturing with embedded knit expertise.",
  ogImage: media("example-monkey.webp"),
};

export const PRICING_META: RouteMeta = {
  path: `${import.meta.env.BASE_URL}start`,
  title: "Pricing — LOOP™ by VARIANT3D",
  description: `LOOP Studio Seats and ${EXPORT_TIER} terms. One seat covers the software, the knit engineering and production at ${PRODUCTION_FACILITY}. Save ${ANNUAL_DISCOUNT_PERCENT}% on annual billing.`,
  ogTitle: "Pricing — LOOP™ by VARIANT3D",
  ogDescription: `The platform to knit everything. Studio Seats and ${EXPORT_TIER} terms.`,
  ogImage: media("example-monkey.webp"),
};

export const ACCESSIBILITY_META: RouteMeta = {
  path: `${import.meta.env.BASE_URL}accessibility`,
  title: "Accessibility — LOOP™ by VARIANT3D",
  description:
    "How the LOOP website meets WCAG 2.2 Level AA, and how to reach VARIANT3D if something on it gets in your way.",
  ogTitle: "Accessibility — LOOP™ by VARIANT3D",
  ogDescription: "How the LOOP website meets WCAG 2.2 Level AA.",
  ogImage: media("example-monkey.webp"),
};

export const KNITTING_META: RouteMeta = {
  path: `${import.meta.env.BASE_URL}3d-knitting`,
  title: "3D knitting, in action — LOOP™ by VARIANT3D",
  description:
    "How a knitting machine turns one yarn into a shaped 3D piece, course by course: stitches, short rows and shaping, shown with a monkey head knitted from real LOOP data.",
  ogTitle: "3D knitting, in action — LOOP™ by VARIANT3D",
  ogDescription: "Watch a monkey head knit itself, course by course, from real LOOP knit data.",
  ogImage: media("suzanne-knit.jpg"),
};

export const ROUTE_META: readonly RouteMeta[] = [HOME_META, PRICING_META, ACCESSIBILITY_META, KNITTING_META];

export const THEME_COLOR = "#f5f3f0";
